const rankingItems = [
  {
    rank: 1,
    title: '某顶流被拍到与新剧女主深夜同回小区',
    heat: '热度 3568万',
    change: 'up',
    tag: '恋情',
  },
  {
    rank: 2,
    title: '综艺节目片酬曝光，一线明星单期报价惊人',
    heat: '热度 2891万',
    change: 'up',
    tag: '综艺',
  },
  {
    rank: 3,
    title: '知名导演宣布新片选角启动，粉丝疯狂推荐',
    heat: '热度 2456万',
    change: 'new',
    tag: '影视',
  },
  {
    rank: 4,
    title: '音乐盛典获奖名单泄露？主办方回应系彩排',
    heat: '热度 2134万',
    change: 'up',
    tag: '音乐',
  },
  {
    rank: 5,
    title: '当红女星素颜直播翻车，真实颜值引争议',
    heat: '热度 1876万',
    change: 'down',
    tag: '直播',
  },
];

export default function RankingSection() {
  const getRankColor = (rank: number) => {
    if (rank === 1) return 'bg-accent-500';
    if (rank === 2) return 'bg-primary-500';
    if (rank === 3) return 'bg-secondary-500';
    return 'bg-foreground-300';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            吃瓜热榜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            实时更新的热门话题排行，看看今天大家都在关注什么
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 py-4 px-4 border-b border-background-200/60 last:border-0 cursor-pointer hover:bg-background-50 transition-colors rounded-lg group"
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${getRankColor(item.rank)}`}
              >
                <span className="text-xs font-black text-background-50">
                  {item.rank}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-bold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                  {item.title}
                </p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-400">{item.heat}</span>
                  <span className="text-xs font-medium text-primary-500 bg-primary-50 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex-shrink-0">
                {item.change === 'up' && (
                  <span className="text-accent-500 text-lg">
                    <i className="ri-arrow-up-s-line"></i>
                  </span>
                )}
                {item.change === 'down' && (
                  <span className="text-foreground-400 text-lg">
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                )}
                {item.change === 'new' && (
                  <span className="inline-block px-1.5 py-0.5 text-[10px] font-bold bg-primary-100 text-primary-600 rounded whitespace-nowrap">
                    NEW
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}